import { Navigate, useParams } from "react-router-dom";

const SchoolRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const allowedSlugs = JSON.parse(
    localStorage.getItem("school_slugs") || "[]"
  );

  const { school_slug } = useParams();

  // Not logged in
  if (!isLoggedIn) {
    return <Navigate to="/admin" replace />;
  }

  // Invalid or unauthorized school
  if (!school_slug || !allowedSlugs.includes(school_slug)) {
    return <Navigate to="/admin/unauthorized" replace />;
  }

  return children;
};

export default SchoolRoute;
